import React, {Component} from 'react'
import {Card, CardBody, CardHeader, Progress, Row, Col, Spinner} from 'reactstrap';
import { Trans } from "react-i18next";
import moment from 'moment'
import {find_evaluation, evaluation} from '../../config/evaluations'
import {gaugeChart, gaugeChartScore} from '../../utils/graphs_facility'
import DivergentStackedBars from '../DivergentStackedBars'
import ScoreDistribution from '../ScoreDistribution'

class Analysis extends Component{
  
  componentDidMount(){
	  this.props.generate_analysis({selected: this.props.selected_companies})

	  
  }

  componentDidUpdate(){
	  if( this.props.analysis != null){
	    const {analysis, analysis: {selection: {score, expired, leftover} = {}}} = this.props
	    gaugeChartScore({score: score.average_score, name: 'average_score', title: 'Score medio'})
	    gaugeChartScore({score: score.weighted_score, name: 'weighted_score', title: 'Score pesato'})
	    gaugeChart({name: expired_ratio, ratio: expired/leftover})
	  }
  }
  

  render(){
	  const {analysis, analysis: {selection, total} = {}} = this.props;
	  
	  const expositions_scores = selection != null ? (evaluation.map(e => {
	    let exp = selection.expositions_scores.filter(es => es.final_more_score == e.score)[0]
	    return ({
		    category: e.letter,
		    value1: exp != null ? Math.round(parseFloat(exp.leftover-exp.leftover_expired)) : 0,
		    count1: exp != null ? exp.number_of_companies-exp.number_of_expired_companies : 0,
		    value2: exp != null ? Math.round(parseFloat(exp.leftover_expired)) : 0,
		    count2: exp != null ? exp.number_of_expired_companies : 0,
	    })})) : null

	  const dso_distribution = selection != null ?
				                     selection.dso_distribution.sort((a,b) => b.dso_from-a.dso_from).map(x => ({
				                       category: (x.dso_to != null ? `${x.dso_from}-${x.dso_to}` :  `> ${x.dso_from}`),
				                       value1: Math.round(x.leftover),
				                       value2: Math.round(x.leftover_expired),
				                       count1: x.count,
				                       count2: x.count_expired
				                     }))
			                     : null 

	  const CardProgress = ({title, content, progress, color}) => <Card className="flex-fill" style={{height: '100%', marginBottom: '0'}}>
	    <CardHeader>
		    <h5 className="card-title mb-0">{title}</h5>
	    </CardHeader>
	    <CardBody className="d-flex align-items-center ">
		    
		    <div className="col-8" style={{paddingLeft: 0}}>
		      <h2 className="d-flex align-items-center font-weight-light">
			      {content}
		      </h2>
		    </div>
		    {progress != null &&<div className="col-4 text-right" style={{paddingRight: 0}}>
		      <span className="text-muted"><Trans values={{value: progress.current/100}}>standard_formatting.percentage</Trans></span>
		    </div>	}	
	    </CardBody>
	    {progress != null && <Progress style={{height: '3px'}} color={color} value={progress.current} max={progress.maximum} />}
	  </Card>


	  
	  console.log(analysis)
	  
	  if(analysis != null)
	  return (
	  <div>

	    <Row>
		    <Col>
		      <CardProgress title='Selezione'
				                content={<Trans values={{value: selection.total_companies}}>standard_formatting.number</Trans>}
				                progress={{current: selection.total_companies/analysis.total.total_companies*100, maximum: 100}} />
		    </Col>
		    <Col>
		      <CardProgress title='Fatturato da inizio anno'
				                content={<Trans values={{value: Math.round(selection.issued_invoices_total_vat)}}>standard_formatting.currency</Trans>}
				                progress={{current: selection.issued_invoices_total_vat/total.issued_invoices_total_vat*100, maximum: 100}} />
		    </Col>
		    <Col>
		      <CardProgress title={"Fatturato stimato "+ moment().year()} content={<Trans values={{value: Math.round(selection.issued_invoices_total_vat/moment().dayOfYear()*moment().endOf('year').dayOfYear())}}>standard_formatting.currency</Trans>}  />
		    </Col>
	    </Row>
	    <div id="expired_ratio" style={{height: 400}}></div>
	    <Row>
		    <Col>
		      <CardProgress title='ESPOSIZIONE/NOTE CREDITO'
				                color = 'success'
				                content={<React.Fragment><Trans values={{value: Math.round(selection.leftover)}}>standard_formatting.currency</Trans>/<Trans values={{value: Math.round(selection.leftover_negative)}}>standard_formatting.currency</Trans></React.Fragment>}
				                progress={{ current: selection.issued_invoices_total_vat/total.issued_invoices_total_vat*100, maximum: 100}} />
		    </Col>
		    <Col>
		      <CardProgress title='SCADUTO'
				                color = 'danger'
				                content={<Trans values={{value: Math.round(selection.expired)}}>standard_formatting.currency</Trans>}
				                progress={{current: selection.issued_invoices_total_vat/total.issued_invoices_total_vat*100, maximum: 100}} />
		    </Col>
		    <Col>
		      <CardProgress title='DSO'
				                content={<Trans values={{value: Math.round(selection.dso)}}>standard_formatting.number</Trans>}
		      />
		    </Col>
		    <Col>
		      <CardProgress title='DSO PATOLOGICO'
				                content={<Trans values={{value: Math.round(selection.dso_pat)}}>standard_formatting.number</Trans>}
		      />
		    </Col>
	    </Row>

	    <h3 style={{marginTop: '24px'}}>Esposizione in € per fascia di scadenza in giorni</h3>
	    
	    <div className="expositions_days">
		    {selection.exp_days.sort((a,b) => a.day_from>b.day_from || a.day_from==null || b.day_from==null ? 1 : -1).map((e,index) => <div key={index}
		                                                                                                                                    style={{backgroundColor: `hsl(${(index)*10},100%, 50%)`,
			                                                                                                                                          border: `5px solid hsl(${(index)*10},90%, 70%)`,
			                                                                                                                                          color: index<6 ? 'white' : 'black'}}>
		      
		      <div className="value"><Trans values={{value: Math.round(e.exposition)}}>standard_formatting.number</Trans></div>
		      <div className="period">{e.day_from}
			      {e.day_from!=null && e.day_to!=null ? '/' :'' }
			      {e.day_from==null ? '<' :'' }
			      {e.day_to==null ? '>' :'' }
			      {e.day_to}</div>
		      
		    </div>)}
	    </div>
	    
	    <Card>
		    <CardHeader><h2>Distribuzione MORE</h2></CardHeader>
		    <CardBody>
		      <Row>
			      <Col>
              <div className="average_score" style={{height: 300}}></div>
            </Col>
			      <Col>
              <div className="weighted_score" style={{height: 300}}></div>
            </Col>			
		      </Row>
		      <ScoreDistribution score_distribution={selection.score_distribution} />
		    </CardBody>
	    </Card>
	    <Card>
		    <CardHeader><h2>Distribuzione esposizioni e scaduti per classi di rating</h2></CardHeader>
		    <CardBody>
		      <DivergentStackedBars data={expositions_scores} name="ratingsExpositions" />
		    </CardBody>
	    </Card>
	    <Card>
		    <CardHeader><h2>Distribuzione temporale DSO</h2></CardHeader>
		    <CardBody>
		      <DivergentStackedBars data={dso_distribution} name="dsoDistribution" />
		    </CardBody>
	    </Card>
	    
	    
	  </div>
	  )
	  else
	    return   <div className='loadPage loader-overlay' style={{position: 'absolute', height: '100%'}}>

		    <Spinner color="primary" />
	    </div>
  }



}
export default Analysis
